var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"1p"}},[(!_vm.cookieAccepted)?_c('cookie-law',{attrs:{"visible":_vm.cookieBar},on:{"close":function($event){_vm.cookieBar = false}}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }